import * as React from 'react';
import './backButtonHeader.module.scss';
import { ArrowForward } from '../../../../commonv3/components/atoms/icons/Arrows';
import { routingStore } from '../../../../common/stores/routing';
import { EnhancedLocationDescriptor } from '../../../routes';
import { observer } from 'mobx-react';
import { BackButton } from '../../../../commonv3/components/atoms/buttons/BackButton';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
    to: EnhancedLocationDescriptor;
};

export const BackButtonHeader = observer(({ to }: Props) => {
    return (
        <div styleName="back-button-header" onClick={() => routingStore.push(to)}>
            {GlobalStatesV3.viewport.isDesktop ? (
                <span>
                    <ArrowForward />
                    <span styleName="back-button-text">戻る</span>
                </span>
            ) : (
                <BackButton onClick={() => null} />
            )}
        </div>
    );
});
